import DOMPurify from 'dompurify';

// Markdown simple (negritas, cursivas, listas, links) → HTML seguro.
// Misma receta que ChatMessageList.vue (assessment): se escapa todo, se
// convierte lo mínimo y se sanitiza con DOMPurify.

const SANITIZE_CONFIG = {
  ALLOWED_TAGS: ['strong', 'b', 'em', 'i', 'u', 'br', 'p', 'ul', 'ol', 'li', 'a', 'code', 'span'],
  ALLOWED_ATTR: ['href', 'target', 'rel'],
};

const escapeHtml = (str) => String(str)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;');

const inline = (text) => text
  .replace(/`([^`]+)`/g, '<code>$1</code>')
  .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
  .replace(/__([^_]+)__/g, '<strong>$1</strong>')
  .replace(/(^|[^*])\*([^*\n]+)\*/g, '$1<em>$2</em>')
  .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+|mailto:[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');

export function renderMarkdown(raw) {
  if (!raw) return '';
  const lines = inline(escapeHtml(raw)).split('\n');
  let html = '';
  let list = null; // 'ul' | 'ol'
  const close = () => { if (list) { html += `</${list}>`; list = null; } };
  lines.forEach((line) => {
    const ul = line.match(/^\s*[-*]\s+(.*)$/);
    const ol = line.match(/^\s*\d+\.\s+(.*)$/);
    const item = ul || ol;
    if (item) {
      const kind = ul ? 'ul' : 'ol';
      if (list !== kind) { close(); html += `<${kind}>`; list = kind; }
      html += `<li>${item[1]}</li>`;
    } else if (!line.trim()) {
      close();
    } else {
      close();
      html += `<p>${line}</p>`;
    }
  });
  close();
  return DOMPurify.sanitize(html, SANITIZE_CONFIG);
}
